// extracted by mini-css-extract-plugin
export var animationAbsolute = "_19-q";
export var animationRelative = "_19-p";
export var backdropBlur = "_19-0";
export var detailLabelCell = "_19-12";
export var detailTable = "_19-11";
export var detailValueCell = "_19-13";
export var docIconBox = "_19-1d";
export var docIconBoxMd = "_19-1f";
export var docIconBoxSm = "_19-1e";
export var docTypeRow = "_19-16";
export var docTypeRowInner = "_19-17";
export var dropdownMatchDatePicker = "_19-3";
export var evidenceCardContent = "_19-1c";
export var fileUploadSpin = "_19-j";
export var gorgiasOpenButton = "_19-15 _19-d";
export var gorgiasTicketCard = "_19-14";
export var heroModalFooterButton = "_19-18";
export var hiddenContainer = "_19-o";
export var iconPrimary = "_19-1g";
export var iconSecondary = "_19-1h";
export var iconTertiary = "_19-1i";
export var integrationCard = "_19-1";
export var integrationLogoBox = "_19-2";
export var mainColumnSticky = "_19-1b";
export var maxWidthContainer = "_19-19";
export var modalContentBody = "_19-a";
export var modalHeaderImage = "_19-5";
export var modalImageLabel = "_19-7";
export var modalImageOverlay = "_19-6";
export var modalImageSubtitle = "_19-9";
export var modalImageTitle = "_19-8";
export var modalImageWrapper = "_19-4";
export var modalStickyFooter = "_19-b";
export var removeButton = "_19-e";
export var sidebarColumn = "_19-1a";
export var spinner = "_19-i";
export var timelineLine = "_19-y";
export var timelineLineBlack = "_19-10 _19-y";
export var timelineLineGray = "_19-z _19-y";
export var timelineLineHeight = "_19-x";
export var tlDotActivate = "_19-u";
export var tlDotActivateAnim = "_19-t";
export var tlDotHide = "_19-s";
export var tlDotHideAnim = "_19-r";
export var tlLineActivate = "_19-w";
export var tlLineActivateAnim = "_19-v";
export var uploadHint = "_19-n";
export var uploadIconBox = "_19-k";
export var uploadLabel = "_19-m";
export var uploadText = "_19-l";
export var uploadZone = "_19-f";
export var uploadZoneCursorDefault = "_19-h";
export var uploadZoneCursorPointer = "_19-g";
export var uploadedFileRow = "_19-c";
export var viewButton = "_19-d";